module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_01_6NW26_1SC_H0Y.f5dbc8f1.jpg";